var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        filterable: "",
        "filter-method": _vm.filterMethod,
        disabled: _vm.disabled,
        placeholder: "请选择",
      },
      model: {
        value: _vm.val,
        callback: function ($$v) {
          _vm.val = $$v
        },
        expression: "val",
      },
    },
    _vm._l(_vm.copyList, function (item) {
      return _c(
        "el-option",
        { key: item.value, attrs: { label: item.label, value: item.value } },
        [
          _c("span", { staticStyle: { float: "left" } }, [
            _vm._v(_vm._s(item.label)),
          ]),
          _c(
            "span",
            {
              staticStyle: {
                float: "right",
                color: "#8492a6",
                "font-size": "13px",
              },
            },
            [_vm._v(_vm._s(item.name))]
          ),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }